(function() {
  'use strict';

  let variantChangeUnsubscriber = null;

  function updateMediaForVariant(productInfo, variantMediaId) {
    if (!variantMediaId || !productInfo) return;

    const sectionId = productInfo.dataset.section;
    if (!sectionId) return;

    const mediaGallery = productInfo.querySelector('media-gallery');
    if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(`${sectionId}-${variantMediaId}`, true);
    }
  }

  function handleVariantImageClick() {
    const inputs = document.querySelectorAll('.swatch-input__input[data-variant-media-id]');
    inputs.forEach(function(input) {
      if (input.dataset.listenerAttached === 'true') return;
      input.dataset.listenerAttached = 'true';

      input.addEventListener('change', function() {
        if (!this.checked) return;
        
      });
    });
  }

  let setupAttempts = 0;
  const MAX_SETUP_ATTEMPTS = 50;

  function setupVariantChangeListener() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      setupAttempts++;
      if (setupAttempts < MAX_SETUP_ATTEMPTS) {
        setTimeout(setupVariantChangeListener, 100);
      }
      return;
    }

    setupAttempts = 0;

    if (variantChangeUnsubscriber) {
      variantChangeUnsubscriber();
      variantChangeUnsubscriber = null;
    }
    
  }

  function initVariantImageSwitch() {
    try {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          try {
            handleVariantImageClick();
            setupVariantChangeListener();
          } catch (e) {
            console.error('Error initializing variant image switch:', e);
          }
        });
      } else {
        handleVariantImageClick();
        setupVariantChangeListener();
      }

      // Re-initialize when variant selects are updated
      const observer = new MutationObserver(function(mutations) {
        let shouldReinit = false;
        try {
          mutations.forEach(function(mutation) {
            if (mutation.addedNodes && mutation.addedNodes.length) {
              for (let i = 0; i < mutation.addedNodes.length; i++) {
                const node = mutation.addedNodes[i];
                if (node && node.nodeType === 1) {
                  if (node.classList && node.classList.contains('swatch-input__input')) {
                    shouldReinit = true;
                    return;
                  }
                  if (node.querySelector && node.querySelector('.swatch-input__input')) {
                    shouldReinit = true;
                    return;
                  }
                }
              }
            }
          });
          if (shouldReinit) {
            setTimeout(function() {
              try {
                handleVariantImageClick();
              } catch (e) {
                console.error('Error reinitializing variant image click handlers:', e);
              }
            }, 100);
          }
        } catch (e) {
          console.error('Error in mutation observer:', e);
        }
      });

      // Observe variant-selects containers
      setTimeout(function() {
        try {
          const variantSelects = document.querySelectorAll('variant-selects');
          for (let i = 0; i < variantSelects.length; i++) {
            observer.observe(variantSelects[i], { childList: true, subtree: true });
          }
        } catch (e) {
          console.error('Error setting up mutation observer:', e);
        }
      }, 500);
    } catch (e) {
      console.error('Error initializing variant image switch:', e);
    }
  }

  // Only initialize if we're in a browser environment
  if (typeof document !== 'undefined') {
    initVariantImageSwitch();
  }
})();

